import React, { useState } from "react";
import { useTranslations } from "next-intl";
import { useTheme } from "@/context/Theme.context";

import { Button, Input, Loader } from "@/components/common";
import PaymentMethods from "../payment-form/payment-methods";
import { PaymentProvider, Theme } from "@/enums";
import {
  useGetPaymentUrlRequest,
  usePaymentCommisionDataRequest,
  usePaymentProvidersDataRequest,
} from "@/api/usePaymentsRequests";
import { formatNumber } from "@/utils/formatNumber";

const RefillBalance = () => {
  const [amount, setAmount] = useState(0);
  const [selectedMethodId, setSelectedMethodId] = useState<
    PaymentProvider | ""
  >("");

  const t = useTranslations();
  const theme = useTheme();

  const handleSelectMethod = (id: PaymentProvider) => {
    setSelectedMethodId(id);
  };

  const { data: paymentProvidersData, isLoading: isPaymentsProvidersLoading } =
    usePaymentProvidersDataRequest(true);

  const { data: paymentCommissionData, isLoading: isCommissionLoading } =
    usePaymentCommisionDataRequest({
      totalAmount: amount,
    });

  const { data: paymentUrlData } = useGetPaymentUrlRequest({
    totalAmount: amount,
    selectedMethodId,
    enabled: true,
  });

  const providersList = paymentProvidersData?.data?.data || [];
  const paymentUrl = paymentUrlData?.data?.data;
  const paymentCommission = paymentCommissionData?.data?.data || null;

  const handleSubmit = () => {
    if (!!selectedMethodId && !!paymentUrl) {
      window.open(paymentUrl.urlForPay, "_self");
      return;
    }
  };

  if (isPaymentsProvidersLoading)
    return (
      <div className="flex w-[493px] items-center justify-center">
        <Loader />
      </div>
    );

  const toPayAmount =
    theme === Theme.UK
      ? paymentCommission?.toPayAmountInUsd
      : paymentCommission?.toPayAmountInNational || 0;

  const commissionAmount =
    theme === Theme.UK
      ? paymentCommission?.commissionAmountInUsd
      : paymentCommission?.commissionAmountInNational || 0;

  return (
    <div className="w-[493px]">
      <div className="mb-6">
        <h3 className="mb-3 text-sm font-medium uppercase text-[#b2b2b2]">
          {t("select_amount_to_refill")}
        </h3>
        <Input
          label={
            theme === Theme.UZ ? t("select_amount_uzs") : t("select_amount")
          }
          onChange={(e: any) => {
            setAmount(e.target.value);
          }}
          type="number"
          value={amount}
        />
      </div>
      <PaymentMethods
        isRefillBalance
        showSelectBalance={false}
        providersList={providersList}
        selectedMethodId={selectedMethodId}
        handleSelectMethod={handleSelectMethod}
      />
      <div className="flex flex-col items-center justify-between px-[35px] pb-[24px]">
        <Button
          // loading={isCommissionLoading}
          // disabled={!paymentCommission}
          // onClick={() => startPayShipmentProcess(selectedOrderIds)}
          onClick={handleSubmit}
        >
          <span className="text-sm !font-medium text-white">
            {t("pay")} ({formatNumber((toPayAmount || 0).toFixed(2))}{" "}
            {t(
              theme === Theme.UZ
                ? "uzs"
                : theme === Theme.GEORGIA
                  ? "gel"
                  : "usd",
            )}
            )
          </span>
        </Button>
        <p
          className={`mt-[10px] text-sm font-normal ${theme !== Theme.UK ? "!text-[#0e7A89]" : ""}`}
        >
          {t("bank_commission")}:{" "}
          {isCommissionLoading
            ? ""
            : formatNumber((commissionAmount || 0).toFixed(2))}
        </p>
      </div>
    </div>
  );
};

export default RefillBalance;
